var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.2 22.7",
    style: {
      enableBackground: "new 0 0 84.2 22.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#2D2C30;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -10.6,
    y: 0,
    className: "st0",
    width: 106.2,
    height: 36.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.5,13.1c-1-0.3-1.9-1-2.6-1.9c-1-1.2-1.4-2.7-1.4-4.4c0-2.2,0.8-3.9,2.3-5.1C74,0.6,76.1,0,78.7,0h5.4v22.7 h-1.9v-9.1h-3.8C76.8,13.6,75.5,13.4,74.5,13.1z M79.4,1.8c-0.8,0-1.4,0-1.9,0.1C76.1,2,75,2.4,74.2,3C73,4,72.4,5.2,72.4,6.8 c0,1.1,0.3,2,0.8,2.8c0.6,0.9,1.4,1.5,2.4,1.8c0.8,0.3,1.9,0.4,3.1,0.4h3.5V1.8H79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.7,1.7C67,2,67.2,2.3,67.2,2.7c0,0.3-0.1,0.6-0.3,0.8c-0.3,0.3-0.6,0.4-1,0.4c-0.3,0-0.6-0.1-0.9-0.3 c-0.3-0.2-0.4-0.6-0.4-0.9c0-0.3,0.1-0.6,0.3-0.9c0.3-0.3,0.6-0.4,0.9-0.4C66.2,1.4,66.5,1.5,66.7,1.7z M66.7,22.7H65V7.1h1.7V22.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.4,14.5c0-1.7,0.5-3.3,1.5-4.7c1.4-2,3.5-3.1,6.1-3.1c2.3,0,4.1,0.8,5.6,2.4c1.4,1.5,2.1,3.5,2.1,5.8 c0,1.4-0.3,2.7-0.9,4c-0.6,1.2-1.4,2.1-2.5,2.8C56.1,22.6,54.6,23,53,23c-1.8,0-3.4-0.6-4.8-1.7c-0.8-0.6-1.4-1.4-1.8-2.2l1.4-0.7 c0.4,0.7,0.9,1.2,1.6,1.7c1.2,0.9,2.4,1.3,3.7,1.3c2,0,3.6-0.8,4.7-2.5c0.6-0.9,1-2,1.1-3.3H45.5C45.4,15.2,45.4,14.8,45.4,14.5z  M58.6,12.8c-0.3-1.3-0.9-2.3-1.8-3.1c-1.1-0.9-2.3-1.3-3.7-1.3c-1.1,0-2.1,0.3-3,0.8c-0.8,0.5-1.4,1.1-1.9,1.8 c-0.5,0.8-0.8,1.8-0.9,3.1h11.6C58.8,13.5,58.7,13.1,58.6,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.6,22.7v-8.2c0-1.1-0.1-1.9-0.3-2.5c-0.2-0.8-0.7-1.6-1.3-2.3c-0.8-0.9-1.9-1.4-3.2-1.4h-0.6V6.8 c0.2,0,0.4,0,0.7,0c1.2,0,2.3,0.3,3.2,1c0.5,0.4,1,1.1,1.5,2V7.1h1.7v15.6H39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.1,22.7v-8.2c0-1.1-0.1-1.9-0.3-2.5c-0.2-0.8-0.7-1.6-1.3-2.3c-0.8-0.9-1.9-1.4-3.2-1.4h-0.6V6.8 c0.2,0,0.4,0,0.7,0c1.2,0,2.3,0.3,3.2,1c0.5,0.4,1,1.1,1.5,2V7.1h1.7v15.6H29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.3,14.5c0-1.7,0.5-3.3,1.5-4.7c1.4-2,3.5-3.1,6.1-3.1c2.3,0,4.1,0.8,5.6,2.4c1.4,1.5,2.1,3.5,2.1,5.8 c0,1.4-0.3,2.7-0.9,4c-0.6,1.2-1.4,2.1-2.5,2.8C17,22.6,15.5,23,13.9,23c-1.8,0-3.4-0.6-4.8-1.7c-0.8-0.6-1.4-1.4-1.8-2.2l1.4-0.7 c0.4,0.7,0.9,1.2,1.6,1.7c1.2,0.9,2.4,1.3,3.7,1.3c2,0,3.6-0.8,4.7-2.5c0.6-0.9,1-2,1.1-3.3H6.4C6.3,15.2,6.3,14.8,6.3,14.5z  M19.5,12.8c-0.3-1.3-0.9-2.3-1.8-3.1c-1.1-0.9-2.3-1.3-3.7-1.3c-1.1,0-2.1,0.3-3,0.8c-0.8,0.5-1.4,1.1-1.9,1.8 c-0.5,0.8-0.8,1.8-0.9,3.1h11.6C19.7,13.5,19.6,13.1,19.5,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.3,20.4c0.3,0.3,0.5,0.6,0.5,1.1c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1,0.4c-0.4,0-0.7-0.1-0.9-0.3 c-0.3-0.3-0.5-0.6-0.5-1c0-0.4,0.1-0.7,0.4-1c0.3-0.3,0.6-0.4,1-0.4C1.7,20.1,2,20.2,2.3,20.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ba67171c57511d04e7ee5c292ee93918.svg";
export { ForwardRef as ReactComponent };